export default __webpack_public_path__ + "static/media/jeevan.047f792c.jpg";